// src/api/lawyerApi.js
import { apiClient, getAuthHeader } from "./apiConfig";

// ------ Lawyers ------
export const fetchAllLawyers = async () => {
  // read current user
  let user = {};
  try {
    user = JSON.parse(localStorage.getItem("user")) || {};
  } catch { }

  const isAdmin = user?.role === "admin";
  const isFirm = user?.role === "firm";

  // if your backend supports filtering by firm_id via query param, send it:
  const params = {};
  if (isFirm && user?.id) params.firm_id = user.id; // GET /lawyers/get_all?firm_id=123

  const res = await apiClient.get(`/lawyers/get_all`, {
    ...getAuthHeader(),
    params,
  });

  const list = res.data?.data || [];


  return list.filter((u) => u.role === "lawyer");
};

export const deleteLawyerById = async (id) => {
  return await apiClient.delete(`/lawyers/delete/${id}`, getAuthHeader());
};

// ------ Location ------
export const fetchCountries = async () => {
  const res = await apiClient.get(`/location/countries`, getAuthHeader());
  return res.data?.data || [];
};

export const fetchStates = async (countryId) => {
  const res = await apiClient.get(`/location/states/${countryId}`, getAuthHeader());
  return res.data?.data || [];
};

export const fetchCities = async (stateId) => {
  const res = await apiClient.get(`/location/cities/${stateId}`, getAuthHeader());
  return res.data?.data || [];
};

// ------ Firms (for lawyer dropdowns, etc.) ------
export const fetchFirms = async () => {
  const res = await apiClient.get(`/firms/get_all`, getAuthHeader());
  return (res.data?.data || []).filter((u) => u.role === "firm");
};

// ------ Create / Update Lawyer (multipart) ------
export const createLawyer = async (formData) => {
  const auth = getAuthHeader();
  return await apiClient.post(`/lawyers/create`, formData, {
    ...auth,
    headers: {
      ...(auth.headers || {}),
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateLawyer = async (userId, formData) => {
  const auth = getAuthHeader();
  return await apiClient.post(`/lawyers/update/${userId}`, formData, {
    ...auth,
    headers: {
      ...(auth.headers || {}),
      "Content-Type": "multipart/form-data",
    },
  });
};
